import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { NoSearchResultsIcon } from '@/shared/assets/icons/no-search-results-icon';

export const EmptyResults = () => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      gap="0.5rem"
      alignItems="center"
      height="100%"
      minHeight="75px"
      justifyContent="center"
    >
      <NoSearchResultsIcon variant="primary" />
      <Typography variant="p7">{t('ui:no_matches_found')}</Typography>
    </Stack>
  );
};
